import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types'; // ES6

class BrandColumn extends React.Component {
    constructor(props) {
      super(props)
    }
    render() {
        return (
            <div id="brand-column" style={{display: 'flex'}} className={`${this.props.location.pathname !== '/' ? 'has-parky' : ''}`}>
                <div></div>
            </div>
        )
    }
}

BrandColumn.propTypes = {
    timeout: PropTypes.bool
}

export default connect()(withRouter(BrandColumn));



// WEBPACK FOOTER //
// ./src/components/BrandColumn.js